/** ReadMeRenderer.tsx */
import React from "react";
import { style, classes } from "./readmerenderer.st.css";
/** Importing a dark theme for readme files code examples. Where we show code usage. */
import "prism-themes/themes/prism-atom-dark.css";

export interface ReadMeRendererProps {
  // Component markdown file name that is passed in.
  component?: string;
  path?: string;
  className?: string;
}

// Markdown component setup, mainly the ID is useful for anchoring to sections within the docs.
// @TODO: Refactor below with more automated way
const MarkDownH1 = (props: any) => {
  return (
    <h1 id={props.id} className={style(classes.title1, classes.underline)}>
      {props.children}
    </h1>
  );
};

const MarkDownH2 = (props: any) => {
  return (
    <h2 id={props.id} className={style(classes.title2, classes.underline)}>
      {props.children}
    </h2>
  );
};

const MarkDownH3 = (props: any) => {
  return (
    <h3 id={props.id} className={classes.title3}>
      {props.children}
    </h3>
  );
};

const MarkDownH4 = (props: any) => {
  return (
    <h4 id={props.id} className={classes.title4}>
      {props.children}
    </h4>
  );
};

const MarkDownP = (props: any) => {
  return (
    <p id={props.id} className={classes.paragraph}>
      {props.children}
    </p>
  );
};

const MarkDownPre = (props: any) => {
  return (
    <pre id={props.id} className={classes.pre}>
      {props.children}
    </pre>
  );
};

const MarkDownUl = (props: any) => {
  return (
    <ul id={props.id} className={classes.basicList}>
      {props.children}
    </ul>
  );
};

const MarkDownLi = (props: any) => {
  return (
    <li id={props.id} className={classes.basicListItem}>
      {props.children}
    </li>
  );
};

class ReadMeRenderer extends React.Component<ReadMeRendererProps, object> {
  render() {
    const ReadMeMdx = React.lazy(
      () =>
        import(
          `!babel-loader!mdx-loader!../../../${this.props.path}/README.mdx`
        )
    );
    return (
      <React.Suspense fallback={<p>Loading...</p>}>
        <section className={style(classes.root, this.props.className)}>
          <ReadMeMdx
            components={{
              h1: MarkDownH1,
              h2: MarkDownH2,
              h3: MarkDownH3,
              h4: MarkDownH4,
              p: MarkDownP,
              pre: MarkDownPre,
              ul: MarkDownUl,
              li: MarkDownLi
            }}
          />
        </section>
      </React.Suspense>
    );
  }
}

export default ReadMeRenderer;
